import { Text } from '@querodelivery/uni-react';
import type { ESlaLevel } from '../../constants';
import { formatElapsedTime } from '../../utils';
import styles from './elapsed-time.module.scss';

interface ElapsedTimeProps {
  elapsedMinutes: number;
  slaLevel: ESlaLevel;
}

export function ElapsedTime({ elapsedMinutes, slaLevel }: ElapsedTimeProps) {
  return (
    <span className={styles.elapsedTime} data-sla-level={slaLevel}>
      <Text
        as="span"
        fontSize="md"
        fontWeight="semibold"
        lineHeight="lg"
        tone="inherit"
      >
        {formatElapsedTime(elapsedMinutes)}
      </Text>
    </span>
  );
}
